import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import { hasAnalyticsConsent } from './consent'

const noop = () => {}
const analyticsFallback = {
  page: noop,
  event: noop,
  query: noop,
  ecommerce: {
    addItem: noop,
    addTransaction: noop,
    send: noop
  }
}

let googleAnalyticsEnabled = false

export function installAnalyticsFallback() {
  if (!Vue.prototype.$ga) {
    Vue.prototype.$ga = analyticsFallback
  }
}

export function enableGoogleAnalytics(router) {
  if (googleAnalyticsEnabled) return true
  if (!hasAnalyticsConsent()) return false

  Vue.use(VueAnalytics, {
    id: 'UA-1849208-1',
    ecommerce: {
      enabled: true
    },
    router,
    autoTracking: {
      page: false
    }
  })

  googleAnalyticsEnabled = true
  return true
}
